<template>
    <v-container  
        fluid
        :class="{
            'container-full-bg-gray': true,
            'pa-0': is_mobile,
            'rounded-mobile': is_mobile
        }" 
    >
        <v-snackbar v-if="screen_data" v-model="screen_data.snackbar.isVisible" :color="screen_data.snackbar.color"
            :timeout="screen_data.snackbar.timeout">
            {{ screen_data.snackbar.text }}
        </v-snackbar>

        <v-dialog v-model="screen_data.deletePopup" persistent max-width="500">
            <v-card class="rounded-xl">
                <v-card-title>
                    <span class="primary__blue">Eliminar servicios recurrentes</span>
                </v-card-title>
                <v-divider></v-divider>
                <v-card-text class="pt-4">
                    <p> Esta acción eliminará los servicios recurrentes seleccionados.</p>
                    <p class="my-0">¿Desea continuar?</p>
                </v-card-text>
                <v-card-actions class="acction_btns">
                    <v-spacer></v-spacer>
                    <v-btn outlined @click="previewDeletetDialog(false)" class="action__btn">Cancelar</v-btn>
                    <v-btn color="primary_blue" class="white--text action__btn" @click="deleteContracts()">
                        Aceptar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-if="screen_data && got_feature('feature_import_recurring_invoices_excel')" v-model="screen_data.excelPopup" max-width="660">
            <v-card class="rounded-lg">
                <v-card-title>
                    <span class="text-h6 primary__blue">Subir fichero Excel de Servicios Recurrentes</span>
                </v-card-title>
                <v-divider></v-divider>
                <v-card-text>
                    <v-container class="px-7">
                        <v-row>
                            <v-col align="center" class="pa-0">
                                <v-icon color="primary_blue" size="55" class="material-symbols-outlined">table_chart</v-icon>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col class="pt-0" align="center">
                                <span class="text-h6 primary__blue">Orden Cabecera</span>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col align="center">
                                <p class="mb-1">Necesitamos la siguiente estructura:</p>
                                <p class="caption font-weight-bold mb-2">
                                    CIF / Serie / Intervalo / Gestión de periodos / Fecha inicio / Fecha final * /
                                    Vencimiento / Descripción / Precio Unitario / Cantidad / IVA / Tipo 0% * /
                                    Retención / Información Adicional / Observaciones / Método de pago
                                </p>
                                <p class="grey--text text--darken-1 caption mt-2">* <strong>Fecha final</strong> es opcional, <strong>Tipo 0%</strong> solo debe indicarse cuando IVA sea 0%</p>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="12">
                                <v-file-input
                                    class="rounded-lg"
                                    label="Archivo"
                                    v-model="screen_data.file"
                                    prepend-icon="mdi-paperclip"
                                    color="primary"
                                    accept=".xls, .xlsx, .xlsm, .ods"
                                    :clearable="false"
                                    :loading="false"
                                    :rules="[v => !!v || 'Archivo requerido']"
                                    outlined
                                ></v-file-input>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-card-text>
                <v-card-actions class="acction_btns">
                    <v-spacer></v-spacer>
                    <v-btn outlined @click="screen_data.cancelPopup()" class="action__btn">Cancelar</v-btn>
                    <v-btn
                        color="primary_blue"
                        class="white--text action__btn"
                        @click="uploadExcelFile()"
                        :disabled="!screen_data.file"
                    >
                        Subir
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!-- Pop-up Actualizar bases precios por % -->
        <v-dialog v-if="got_feature('feature_adjust_facturae_bases_percent')" v-model="screen_data.adjustPricePercentPopup" persistent max-width="500">
            <v-card class="rounded-xl">
                <v-card-title>
                    <span class="primary__blue">Actualizar bases y precios</span>
                </v-card-title>
                <v-divider></v-divider>
                <v-card-text class="pt-4">
                    <p>Introduzca el porcentaje de ajuste para actualizar las bases y precios de los servicios recurrentes seleccionados.</p>
                    <p class="grey--text text--darken-1 caption">Puede introducir valores decimales y negativos (para reducir los precios).</p>
                    <v-text-field
                        v-model.number="screen_data.adjustPricePercent"
                        label="Porcentaje (%)"
                        type="number"
                        outlined
                        dense
                        class="mt-2"
                        placeholder="Ej: 5,2 para incremento del 5,2%"
                    ></v-text-field>
                </v-card-text>
                <v-card-actions class="acction_btns">
                    <v-spacer></v-spacer>
                    <v-btn outlined @click="setAdjustPricePercentPopup(false)" class="action__btn">Cancelar</v-btn>
                    <v-btn
                        color="primary_blue"
                        class="white--text action__btn"
                        @click="adjustBasesByPercent()"
                        :disabled="screen_data.adjustPricePercent == null || screen_data.adjustPricePercent === ''"
                    >
                        Confirmar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!-- Pop-up Actualizar bases precios por valor fijo -->
        <v-dialog v-if="got_feature('feature_adjust_facturae_bases_percent')" v-model="screen_data.adjustPriceFixedPopup" persistent max-width="500">
            <v-card class="rounded-xl">
                <v-card-title>
                    <span class="primary__blue">Actualizar precios</span>
                </v-card-title>
                <v-divider></v-divider>
                <v-card-text class="pt-4">
                    <p>Introduzca el número de ajuste para actualizar los precios unitarios de todas las líneas de los servicios recurrentes seleccionados.</p>
                    <p class="grey--text text--darken-1 caption">Puede introducir valores decimales y negativos (para reducir los precios).</p>
                    <v-text-field
                        v-model.number="screen_data.adjustPriceFixed"
                        label="Número"
                        type="number"
                        outlined
                        dense
                        class="mt-2"
                        placeholder="Ej: 1,4 para sumar 1,4 a cada precio unitario"
                    ></v-text-field>
                </v-card-text>
                <v-card-actions class="acction_btns">
                    <v-spacer></v-spacer>
                    <v-btn outlined @click="setAdjustPriceFixedPopup(false)" class="action__btn">Cancelar</v-btn>
                    <v-btn
                        color="primary_blue"
                        class="white--text action__btn"
                        @click="adjustBasesByFixed()"
                        :disabled="screen_data.adjustPriceFixed == null || screen_data.adjustPriceFixed === ''"
                    >
                        Confirmar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="screen_data.forceGeneratePopup" persistent max-width="500">
            <v-card class="rounded-xl">
                <v-card-title>
                    <span class="primary__blue">Forzar generación de facturas</span>
                </v-card-title>
                <v-divider></v-divider>
                <v-card-text class="pt-4">
                    <p>Esta acción generará facturas de los servicios recurrentes seleccionados.</p>
                    <p class="my-0">¿Desea continuar?</p>
                </v-card-text>
                <v-card-actions class="acction_btns">
                    <v-spacer></v-spacer>
                    <v-btn outlined @click="screen_data.forceGeneratePopup = false" class="action__btn">Cancelar</v-btn>
                    <v-btn color="primary_blue" class="white--text action__btn" @click="confirmForceGenerate()">
                        Confirmar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-card width="100%" :class="{'rounded-10': true, 'pa-0': is_mobile}">

            <v-card-title :class="['primary--text text--darken-2 px-5 pb-0 d-flex card-title-footer-color', {'card-title--modifier' : is_mobile}]">
                <div class="mr-0 d-flex align-center">
                    <v-btn icon
                        @click="backToList()">
                        <AppIcon :src="require('../../../assets/back-arrow.svg')" :size="20" :preserveColors="true"/>
                    </v-btn>
                    <h3 class="primary_blue--text ml-1" ><span>Listado de Servicios Recurrentes</span></h3>
                </div>
                <v-row class="pa-0 ma-0">
                    <!-- Campo Buscador -->
                    <v-col cols="3" class="pa-0 ma-0"> </v-col>
                    <v-col cols="9" class="pa-0 ma-0">
                        <slot name="search_right">

                            <div class="d-flex justify-end align-center" align="right">
                                <v-tooltip top v-if="got_feature('feature_import_recurring_invoices_excel')">
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn @click="openExcelUploadDialog()" color="primary_blue" icon v-bind="attrs" v-on="on">
                                            <v-icon>mdi-upload</v-icon>
                                        </v-btn>
                                    </template>
                                    <span>Subir Excel de Servicios Recurrentes</span>
                                </v-tooltip>
                                <v-tooltip top>
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn @click="refreshList()" color="primary_blue" icon v-bind="attrs" v-on="on"
                                            :loading="screen_data.loadingItems">
                                            <v-icon>mdi-refresh</v-icon>
                                        </v-btn>
                                    </template>
                                    <span>Actualizar</span>
                                </v-tooltip>
                                <v-tooltip top>
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-btn color="primary_blue" @click="openRecurringInvoiceEditor"
                                                icon v-bind="attrs" v-on="on">
                                                <v-icon>mdi-plus</v-icon>
                                            </v-btn>
                                        </template>
                                        <span>Añadir</span>
                                </v-tooltip>
                                <v-tooltip top>
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn color="primary_blue" icon v-bind="attrs" v-on="on"
                                            :disabled="!screen_data.selectedItems.length"
                                            @click="previewDeletetDialog(true)">
                                            <v-icon>mdi-delete</v-icon>
                                        </v-btn>
                                    </template>
                                    <span>Eliminar</span>
                                </v-tooltip>
                                <v-menu
                                    offset-y
                                    v-model="screen_data.actionMenu"
                                >
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn
                                        v-bind="attrs" 
                                        v-on="on"
                                        icon
                                        color="primary_blue"
                                        >
                                            <AppIcon :src="require('@/assets/btn-show-menu.svg')" :size="29" :color-map="{ '060647': 'primary_blue' }"/>
                                        </v-btn>
                                    </template>
                                    <v-list>
                                        <v-list-item
                                            link
                                            @click="$router.push({ 'name': 'product-list', 'params': { 'companydb_id': companydb_id }})"
                                        >
                                            <v-list-item-title>Productos</v-list-item-title>
                                        </v-list-item>
                                        <v-list-item
                                            link
                                            @click="openForceGeneratePopup()"
                                            :disabled="!screen_data.hasActiveContract"
                                        >
                                            <v-list-item-title>Forzar generación de facturas</v-list-item-title>
                                        </v-list-item>
                                        <div v-if="got_feature('feature_adjust_facturae_bases_percent')">
                                            <v-list-item
                                                @click="openAdjustPricePercentPopup()"
                                            >
                                                <v-list-item-title>Actualizar bases y precios según porcentaje</v-list-item-title>
                                            </v-list-item>
                                            <v-list-item
                                                @click="openAdjustPriceFixedPopup()"
                                            >
                                                <v-list-item-title>Actualizar bases y precios según valor fijo</v-list-item-title>
                                            </v-list-item>
                                        </div>
                                    </v-list>
                                </v-menu>
                            </div>
                        </slot>
                    </v-col>
                </v-row>
            </v-card-title>
            
            <v-card-text class="px-0 pt-0 card-title-footer-color">
                <v-row :class="{'ma-1': is_mobile, 'pa-0': is_mobile,'justify-center': is_mobile, 'ma-0': !is_mobile}">
                    <app-search-bar
                        :filters="screen_data.availableFilters"
                        @updateObject="updateFilter"
                        @resetAllFilters="removeAllFilt"
                    />
                </v-row>
                <v-data-table
                    :class="{ 'mobile-table': is_mobile }"
                    v-model="screen_data.selectedItems" 
                    :items="screen_data.recurringInvoices"
                    :footer-items-per-page-text="screen_data.footerItemsPerPageText"
                    :footer-items-per-page-options="screen_data.footerItemsPerPageOptions"
                    :headers="screen_data.recurringInvoicesHeaders"
                    :show-select="screen_data.showSelect"
                    :loading="screen_data.loadingItems"
                    :server-items-length="screen_data.totalItems"
                    :footer-props="{
                        'items-per-page-text': is_mobile ? '' : screen_data.footerItemsPerPageText,
                        'items-per-page-options': screen_data.footerItemsPerPageOptions,
                    }" 
                    :no-data-text="screen_data.textNoResults" 
                    :loading-text="screen_data.textLoading" 
                    fixed-header
                    :item-key="screen_data.itemKey"
                    @click:row="selectRow"
                    @update:sort-by="sortTable"
                    @update:sort-desc="sortTableDesc"
                    @update:items-per-page="changeLimit"
                    @update:page="changeOffset"
                    >
                    <!-- Cols -->
                    <template v-for="header in screen_data.recurringInvoicesHeaders" v-slot:[`item.${header.value}`]="{ item }">
                        <span class="font-color">
                            <slot v-if="header.value == 'customer_name'" :name="header.value" v-bind="item">
                                <span v-if="item.invoice && item.invoice.customer">
                                    <span v-if="item.invoice.customer.type == 'fisica'">{{item.invoice.customer.first_surname}} {{item.invoice.customer.second_surname}}, {{item.invoice.customer.name}}</span>
                                    <span v-else>{{ item.invoice.customer.business_name }}</span>
                                </span>
                                <span v-else>-</span>
                            </slot>
                            <slot v-else-if="['start_date', 'end_date'].includes(header.value)" :name="header.value" v-bind="item">
                                <span v-if="item && item[header.value]">
                                    {{ formatDate(item[header.value]) }}
                                </span>
                                <span v-else>-</span>
                            </slot>
                            <slot v-else-if="header.value == 'total_amount'" :name="header.value" v-bind="item">
                                {{ (Math.round(item.invoice[header.value]*100 ) /100) }} €
                            </slot>
                            <slot v-else-if="header.value == 'state'" :name="header.value" v-bind="item">
                                {{ stateTranslator(item[header.value]) }}

                            </slot>
                            <slot v-else-if="header.value == 'id'" :name="header.value" v-bind="item">
                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on, attrs }">
                                        <div
                                        class="tooltip-container"
                                            @contextmenu.prevent="copyToClipboard(item[header.value])"
                                            v-bind="attrs"
                                            v-on="on"
                                        >
                                        {{ item[header.value] }}
                                    </div>
                                </template>
                                <span>Click derecho para copiar ID</span>
                                </v-tooltip>
                            </slot>
                            <slot v-else :name="header.value" v-bind="item">
                                <span :class="['interval', 'period'].includes(header.value) ? 'text-capitalize' : ''">
                                    {{item[header.value] }}
                                </span>
                            </slot>
                        </span>
                    </template>
                    <template v-if="screen_data.hideHeaderCheckbox" #header.data-table-select></template>
                    <!-- Header -->
                    <template v-for="header in screen_data.recurringInvoicesHeaders" v-slot:[`header.${header.value}`]="{ header }">
                        <v-checkbox v-if="header.checkbox" class="ma-0 pa-0"
                            :value="header.selected" hide-details>
                            <template v-slot:label>
                                <span>{{ header.text }}</span>
                            </template>
                        </v-checkbox>
                        <span v-else tabindex="0">
                            {{ header.text }}
                        </span>
                    </template>
                    <!--Footer-->
                    <template v-slot:[`footer.page-text`]="items">
                        {{ items.pageStart }} - {{ items.pageStop }} de
                        {{ items.itemsLength }}
                    </template>
                </v-data-table>
            </v-card-text>
        </v-card>
        
    </v-container>
</template>

<script>
import { MemoryRecurringInvoiceRepository } from "@/modules/facturae/infra/MemoryRecurringInvoices";
import { VueRecurringInvoiceListScreenData } from "@/modules/facturae/infra/VueRecurringInvoiceListScreenData";
import { mapGetters, mapState } from "vuex";
import { RecurringInvoiceListComponent } from "@/modules/facturae/app/RecurringInvoiceListComponent";
import AppSearchBar from '@/components/layout/AppSearchBar.vue';
import { ApiConfigurationRepository } from "./ApiConfigurationRepository";
import { RecurringInvoiceContract, IntervalConfiguration } from "@/modules/facturae/domain/RecurringInvoiceContract.ts";
import { Party, Tax, InvoiceLine } from "@/modules/facturae/domain/Invoiceable";
import { ApiRecurringInvoiceRepository } from "./ApiRecurringInvoiceRepository";
import { ApiInvoiceableRepository } from "./ApiInvoiceableRepository";
import awsconfig from '@/aws-exports';
import { S3Repository } from "@/modules/shared/infra/S3Repository";

export default {
    name: "recurring-invoice-list",
    components: {
        AppSearchBar,
    },
    data() {
        const screen_data = new VueRecurringInvoiceListScreenData();
        return {
            screen_data:screen_data,
            recurring_invoice_list_component:null,
        };
    },
    props: {
        companydb_id: {
            type: [Number, String],
            required: true,
        },
    },
    watch: { 
        companydb_id: function() {
            this.recurring_invoice_list_component.mountList(this.companydb_id)
        }
    },
    async mounted() {
        this.creds = new AWS.CognitoIdentityCredentials({
            IdentityPoolId: awsconfig['aws_cognito_identity_pool_id']
        });
        this.creds.params.Logins = this.creds.params.Logins || {};
        this.creds.params.Logins['cognito-idp.eu-west-1.amazonaws.com/' + awsconfig['aws_user_pools_id']] = this.session_information.signInUserSession.idToken.jwtToken;
        this.creds.expired = true;
        AWS.config.update({
            region: awsconfig['aws_user_files_s3_bucket_region'],
            credentials: this.creds,
        });
        let s3_repo = new S3Repository(AWS, 'recurring_invoice') // 'excel_lines'
        let recurring_invoice_repository = new ApiRecurringInvoiceRepository();
        let invoiceable_repository = new ApiInvoiceableRepository();
        this.recurring_invoice_list_component = new RecurringInvoiceListComponent(recurring_invoice_repository, this.screen_data, invoiceable_repository, s3_repo);
        // esto ya no hace falta porque he desactivado los botones que requieren de tener contrato de factura electrónica (si ves esto, borralo :) )
        // let has_contract = await this.recurring_invoice_list_component.companyHasActiveEinvoiceContract(this.companydb_id)
        // if (!has_contract){
        //     this.$router.push({ name: 'invoice-list', params: { 'companydb_id': this.companydb_id } });
        // }
        await this.recurring_invoice_list_component.mountList(this.companydb_id)
    },
    methods: {
        async updateFilter(params){
            this.recurring_invoice_list_component.updateFilters(params)
            await this.recurring_invoice_list_component.mountList(this.companydb_id)
        },
        async removeAllFilt(p){
            this.recurring_invoice_list_component.celanAllFilters()
            await this.recurring_invoice_list_component.mountList(this.companydb_id)
        },
        async refreshList(){
            await this.recurring_invoice_list_component.mountList(this.companydb_id)
        },
        openRecurringInvoiceEditor() {
            this.$router.push({ 'name': 'recurring-invoice-editor', 'params': { 'companydb_id': this.companydb_id}})
        },
        selectRow(item) {
            this.$router.push({ 'name': "recurring-invoice-editor", 'params': { 'companydb_id': this.companydb_id, 'recurring_invoice_id': item.id }})
        },
        sortTable(value){
            if (value.length){
                this.screen_data.sort_by = value[0]
                this.recurring_invoice_list_component.mountList(this.companydb_id)
            }
            else{
                this.screen_data.sort_by = ''
                this.recurring_invoice_list_component.mountList(this.companydb_id)
            }
        },
        sortTableDesc(value){
            if (value.length && value[0]){
                this.screen_data.sort_by = '-'+this.screen_data.sort_by
                this.recurring_invoice_list_component.mountList(this.companydb_id)
            }
        },
        changeLimit(value){
            this.screen_data.limit = value
            this.recurring_invoice_list_component.mountList(this.companydb_id)
        },
        changeOffset(value){
            this.screen_data.offset = (value-1)*this.screen_data.limit
            this.recurring_invoice_list_component.mountList(this.companydb_id)
        },
        formatDate(date) {
            let d = new Date(date);
            if (isNaN(d)) {
                return date;
            } else if (!date) {
                return '';
            }
            let day = String(d.getDate()).padStart(2, '0');
            let month = String(d.getMonth() + 1).padStart(2, '0');
            let year = d.getFullYear();
            return `${day}/${month}/${year}`;
        },
        formattedDate(date) {
            return date ? new Date(date).toLocaleDateString('es-ES', {
                day: '2-digit',
                month: '2-digit',
                year: 'numeric'}) : '';
        },
        stateTranslator(state) {
            switch (state) {
                case 'not_started':
                    return 'No iniciado';
                case 'started':
                    return 'En curso';
                case 'stopped':
                    return 'Detenido';
                case 'finished':
                    return 'Finalizado';
                default:
                    return state;
            }
        },
        async createinvoice() {
            await this.recurring_invoice_list_component.generateInvoiceFromContract()
        },
        async confirmForceGenerate() {
            this.screen_data.forceGeneratePopup = false
            await this.createinvoice()
        },
        previewDeletetDialog(value) {
            this.screen_data.deletePopup = value
        },
        async deleteContracts() {
            this.previewDeletetDialog(false)
            await this.recurring_invoice_list_component.deleteContracts()
            await this.recurring_invoice_list_component.mountList(this.companydb_id)
        },
        backToList() {
            this.$router.push({ name: 'invoice-list', params: { 'companydb_id': this.companydb_id } });
            return
        },
        copyToClipboard(id) {
            navigator.clipboard.writeText(id).then(() => {
                this.screen_data.success_message('ID copiado al portapapeles');
            }).catch(err => {
                this.screen_data.error_message('Error al copiar el ID: ', err);
            });
        },
        async openExcelUploadDialog() {
            let res = await this.screen_data.askForFile()
            if (res && this.screen_data.file) {
                // File is ready to be uploaded when uploadExcelFile is called
            } else {
                // User cancelled the dialog
                this.screen_data.file = null
            }
        },
        async uploadExcelFile() {
            if (!this.screen_data.file) {
                this.screen_data.errorMessage('Por favor, seleccione un archivo')
                return
            }
            let res = await this.recurring_invoice_list_component.importRecurringInvoicesFromExcel(this.companydb_id, this.screen_data.file)
            this.screen_data.confirmPopup()
            this.screen_data.file = null
        },
        setAdjustPricePercentPopup(value) {
            if (value) {
                this.screen_data.adjustPricePercent = null
            }
            this.screen_data.adjustPricePercentPopup = value
        },
        openAdjustPricePercentPopup() {
            const someSelected = this.checkSomeContractsSelected()
            if (someSelected) {
                this.setAdjustPricePercentPopup(true)
            }      
        },
        setAdjustPriceFixedPopup(value) {
            if (value) {
                this.screen_data.adjustPriceFixed = null
            }
            this.screen_data.adjustPriceFixedPopup = value
        },
        openAdjustPriceFixedPopup() {
            const someSelected = this.checkSomeContractsSelected()
            if (someSelected) {
                this.setAdjustPriceFixedPopup(true)
            }
        },
        setConfirmForceGenerate(value) {
            this.screen_data.forceGeneratePopup = value
        },
        openForceGeneratePopup() {
            const someSelected = this.checkSomeContractsSelected()
            if (someSelected) {
                this.setConfirmForceGenerate(true)
            }
        },
        async adjustBasesByPercent() {
            this.setAdjustPricePercentPopup(false)
            if (this.screen_data.adjustPricePercent == null) {
                this.screen_data.errorMessage('Por favor, escriba un número')
                return
            }
            await this.recurring_invoice_list_component.adjustBasesByPercent(this.screen_data.adjustPricePercent)
            this.screen_data.adjustPricePercent = null
            this.refreshList()
        },
        async adjustBasesByFixed() {
            this.setAdjustPriceFixedPopup(false)
            if (this.screen_data.adjustPriceFixed == null) {
                this.screen_data.errorMessage('Por favor, escriba un número')
                return
            }
            await this.recurring_invoice_list_component.adjustBasesByFixed(this.screen_data.adjustPriceFixed)
            this.screen_data.adjustPriceFixed = null
            this.refreshList()
        },
        checkSomeContractsSelected() {
            if (this.screen_data.selectedItems.length == 0) {
                this.screen_data.errorMessage('No hay contratos seleccionados')
                return false
            }
            return true
        },
    },
    computed: {
        ...mapGetters({ 
            got_feature: "got_feature",
            is_mobile: "is_mobile",
        }),
        ...mapState([
            'session_information',
            'currentCompany'
        ]),
    },
};
</script>

<style scoped>

::v-deep .v-card__title {
    padding-top: 15px !important;
    padding-bottom: 15px !important;

}

::v-deep .v-data-table-header>tr>th {
    background-color: var(--v-primaryLight-base) !important;
}

::v-deep .v-data-table-header>tr>th>span,
::v-deep .v-data-table-header>tr>th>div>div>div>label>span {
    color: var(--v-primary-base);
    font-size: 0.875rem;
}

.font-color {
    color: #56565b;
}

::v-deep .v-data-table__wrapper>table>tbody>tr>td {
    border-bottom: none !important;
}

::v-deep tbody tr:nth-of-type(even) {
    background-color: rgba(245, 245, 245, 0.47);
}

::v-deep .v-input__prepend-inner>div>i {
    color: var(--v-primary-base);
    top: 2px;
    padding-left: 5px;
}

.text-field-size {
    font-weight: normal;
    font-size: 0.875rem;
}

::v-deep .input-search .v-input__slot::before {
    border-style: none !important;
}

::v-deep .input-search .v-text-field__slot,
::v-deep .input-search .v-input__prepend-inner,
::v-deep .input-search .v-input__slot {
    background-color: #f2f1ff !important;
}

::v-card-title .title-dialog {
    justify-content: space-around;
}

.btn-right {
    display: flex;
    justify-content: flex-end;
}

.no-underline>>>.v-text-field .v-input__control>.v-input__slot:before {
    border: none;
}
.rounded-10 {
    border-radius: 10px !important;
}

.primary_blue--text {
    color: var(--v-primary_blue-base) !important;
    font-size: 20px;
    font-weight: 600;
}

.theme--light.v-list-item:not(.v-list-item--active):not(.v-list-item--disabled):hover {
    color: var(--v-primary-base) !important;
    background: rgb(102, 51, 153, 0.1) !important;
}

</style>

<!-- Mobile -->
<style>
.card-title--modifier{
    flex-direction: column;
    padding: 15px 0 0 0 !important;
}
.mobile-table .v-data-footer {
    display: flex !important;
    flex-direction: row !important;
    justify-content: center !important;
    align-items: center !important;
    margin-right: 0 !important;
}

.v-card__text{
    padding-bottom: 0 !important;
}
</style>